<template>
  <a-form :form="form.fc" v-bind="formItemLayout">
    <a-form-item :label="$t('scope.text_225', [$t('dictionary.user')])">
      {{ userInfo.name }}
    </a-form-item>
    <a-form-item :label="$t('scope.text_226')">
      <a-input v-decorator="decorators.mobile" />
    </a-form-item>
    <a-form-item :label="$t('scope.text_204')">
      <a-input v-decorator="decorators.email" />
    </a-form-item>
    <a-form-item :label="$t('scope.text_15')">
      <a-switch v-decorator="decorators.enabled" />
    </a-form-item>
  </a-form>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'UserInfoUpdate',
  props: {
    contacts: {
      required: true,
      type: Object,
    },
  },
  data () {
    return {
      form: {
        fc: this.$form.createForm(this),
      },
      decorators: {
        mobile: [
          'mobile',
          {
            validateFirst: true,
            initialValue: this.contacts.mobile.contact,
            rules: [
              { required: true, message: this.$t('scope.text_227') },
              { validator: this.$validate('phone') },
            ],
          },
        ],
        email: [
          'email',
          {
            validateFirst: true,
            initialValue: this.contacts.email.contact,
            rules: [
              { required: true, message: this.$t('scope.text_228') },
              { validator: this.$validate('email') },
            ],
          },
        ],
        enabled: [
          'enabled',
          {
            valuePropName: 'checked',
            initialValue: this.contacts.enabled,
          },
        ],
      },
      formItemLayout: {
        labelCol: {
          sm: { span: 5 },
        },
        wrapperCol: {
          sm: { span: 19 },
        },
      },
    }
  },
  computed: mapGetters(['userInfo']),
  methods: {
    async getValues () {
      try {
        const values = await this.form.fc.validateFields()
        let contacts = []
        if (this.contacts.enabled !== values.enabled) {
          contacts = [
            {
              contact_type: 'email',
              enabled: values.enabled ? 1 : 0,
              contact: values.email,
            },
            {
              contact_type: 'mobile',
              enabled: values.enabled ? 1 : 0,
              contact: values.mobile,
            },
          ]
        } else {
          if (this.contacts.mobile.contact !== values.mobile) {
            contacts.push({
              contact_type: 'mobile',
              enabled: values.enabled ? 1 : 0,
              contact: values.mobile,
            })
          }
          if (this.contacts.email.contact !== values.email) {
            contacts.push({
              contact_type: 'email',
              enabled: values.enabled ? 1 : 0,
              contact: values.email,
            })
          }
        }
        if (contacts.length <= 0) {
          this.$message.warning(this.$t('scope.text_229'))
          throw new Error(this.$t('scope.text_229'))
        }
        return contacts
      } catch (error) {
        throw error
      }
    },
  },
}
</script>
